import {
  UPDATE_SEARCHTDATA_TAIKHOAN_BANK,
  UPDATE_SEARCHTDATA_LICHSU_BANK,
  UPDATE_SEARCHTDATA_CHOTHANHTOAN
} from "./actionTypes";


export const updateDataSearchTaiKhoanBank = (data) => ({
  type: UPDATE_SEARCHTDATA_TAIKHOAN_BANK,
  payload: data,
});
export const updateDataSearchLichSuBank = (data) => ({
  type: UPDATE_SEARCHTDATA_LICHSU_BANK,
  payload: data,
});
export const updateDataSearchChoThanhToan = (data) => ({
  type: UPDATE_SEARCHTDATA_CHOTHANHTOAN,
  payload: data,
});

